import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

export const socialTypes = [
    {
        name: 'Instagram',
        code: 'Instagram',
        prefix: 'https://www.instagram.com/',
        getIcon: () => byPrefixAndName.fab['instagram'],
        urlPattern: /(?:https?:\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\//i,
        skipPathSegments: ['stories'],
    },
    {
        name: 'Facebook',
        code: 'Facebook',
        prefix: 'https://www.facebook.com/',
        getIcon: () => byPrefixAndName.fab['facebook'],
        urlPattern: /(?:https?:\/\/)?(?:www\.)?facebook\.com\//i,
    },
    {
        name: 'X / Twitter',
        code: 'Twitter',
        prefix: 'https://www.twitter.com/',
        getIcon: () => byPrefixAndName.fab['x-twitter'],
        urlPattern: /(?:https?:\/\/)?(?:www\.)?twitter\.com\//i,
    },
    {
        name: 'Models.com',
        code: 'ModelsCom',
        prefix: 'https://www.models.com/',
        getIcon: () => null,
        urlPattern: /(?:https?:\/\/)?(?:www\.)?models\.com\//i,
        preservePath: true,
        defaultPathSegment: 'models',
        validPathSegments: ['agency', 'models', 'people'],
    },
    {
        name: 'TikTok',
        code: 'TikTok',
        prefix: 'https://www.tiktok.com/@',
        getIcon: () => byPrefixAndName.fab['tiktok'],
        urlPattern: /(?:https?:\/\/)?(?:www\.)?tiktok\.com\//i,
    },
    {
        name: 'YouTube',
        code: 'YouTube',
        prefix: 'https://www.youtube.com/',
        getIcon: () => byPrefixAndName.fab['youtube'],
        urlPattern: /(?:https?:\/\/)?(?:m\.)?(?:www\.)?(?:youtube\.com|youtu\.be)\//i,
        preservePath: true,
        // the query string carries the significant part for "watch"/"playlist" links (?v=ID, ?list=ID)
        preserveQuery: true,
        // legacy support: bare channel IDs get "channel/" prepended
        defaultPathPrefix: 'channel/',
        knownPathStarts: ['@', 'channel', 'user', 'watch', 'c/', 'playlist', 'shorts', 'live'],
    },
    {
        name: 'IMDB',
        code: 'IMDB',
        prefix: 'https://www.imdb.com/',
        getIcon: () => byPrefixAndName.fab['imdb'],
        urlPattern: /(?:https?:\/\/)?(?:www\.)?imdb\.com\//i,
        // skipPathSegments: ['name'],
    },
    {
        name: 'LinkedIn',
        code: 'LinkedIn',
        prefix: 'https://www.linkedin.com/in/',
        getIcon: () => byPrefixAndName.fab['linkedin'],
        urlPattern: /(?:https?:\/\/)?(?:www\.)?linkedin\.com\//i,
        skipPathSegments: ['in'],
    },
    {
        name: 'Pinterest',
        code: 'Pinterest',
        prefix: 'https://www.pinterest.com/',
        getIcon: () => byPrefixAndName.fab['pinterest'],
        urlPattern: /(?:https?:\/\/)?(?:www\.)?pinterest\.(?:com|co\.\w+|[a-z]{2,3})\//i,
    },
    {
        name: 'Behance',
        code: 'Behance',
        prefix: 'https://www.behance.net/',
        getIcon: () => byPrefixAndName.fab['behance'],
        urlPattern: /(?:https?:\/\/)?(?:www\.)?behance\.net\//i,
    },
    {
        name: 'Vimeo',
        code: 'Vimeo',
        prefix: 'https://vimeo.com/',
        getIcon: () => byPrefixAndName.fab['vimeo'],
        urlPattern: /(?:https?:\/\/)?(?:www\.)?vimeo\.com\//i,
    },
    {
        name: 'Blog',
        code: 'Blog',
        prefix: '',
        getIcon: () => byPrefixAndName.fasl['rss'],
    },
    {
        name: 'Website',
        code: 'Personal',
        prefix: '',
        getIcon: () => byPrefixAndName.fasl['globe-pointer'],
    },
    {
        name: 'Other',
        code: 'Other',
        prefix: '',
        getIcon: () => byPrefixAndName.fasl['browser'],
    },
];
